import React from 'react';
import Error from './Error';
import './styles.scss';

export default function SystemUnavailable() {
    return (
        <Error headerTxt="We're Sorry">
            <p>We are experiencing a technical issue.</p>
        </Error>
    );
}
